'use strict';
module.exports = function subscriptionPaymentDue(subscription) {
	const overdueStates = ['delinquent', 'overdue'];
	return !!(subscription && overdueStates.includes(subscription.status));
};
